function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable */

import PropTypes from 'prop-types';
import React, { useState } from 'react';
import PubSub from 'pubsub-js';
import Button from '@components/common/form/Button';
import { FORM_SUBMIT, FORM_VALIDATED } from '../../../lib/util/events';
import { serializeForm } from '../../../lib/util/formToJson';
import { get } from '../../../lib/util/get';
import { validator } from './validator';
import { _ } from '@evershop/evershop/src/lib/locale/translate';
export var FormContext = /*#__PURE__*/React.createContext({});
export var FormDispatch = /*#__PURE__*/React.createContext({
  submit: () => {},
  validate: () => {}
});
export function Form(props) {
  var {
    id,
    action,
    method,
    isJSON = true,
    onStart,
    onComplete,
    onError,
    onSuccess,
    onValidationError,
    children,
    submitBtn = true,
    btnText,
    type,
    dataFilter,
    continueButtonClass,
    storeStatus
  } = props;
  var [fields, setFields] = React.useState([]);
  var formRef = React.useRef();
  var [loading, setLoading] = useState(false);
  var [state, setState] = useState('initialized');
  var [showStoreStatus, setShowStoreStatus] = useState(true);
  var addField = function addField(name, value) {
    var validationRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    setFields(previous => {
      if (previous.find(f => f.name === name)) {
        return previous;
      }
      return previous.concat({
        name,
        value,
        validationRules,
        updated: false
      });
    });
  };
  var updateField = function updateField(name, value) {
    var validationRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    setFields(previous => previous.map(f => {
      if (f.name === name) {
        return {
          name,
          value,
          validationRules,
          updated: true
        };
      } else {
        return f;
      }
    }));
  };
  var removeField = name => {
    setFields(previous => previous.filter(f => f.name !== name));
  };

  // In the Form.jsx file, modify the validate function:

  var validate = () => {
    var errors = {};
    fields.forEach(f => {
      f.validationRules.forEach(r => {
        var rule;
        var message;

        // Check if r is a string, an object with rule as string, or an object with rule as function
        if (typeof r === 'string') {
          rule = r;
        } else {
          rule = r.rule;
          message = typeof r.message === 'function' ? r.message(f.value) : r.message;
        }

        // Handle different rule types
        if (typeof rule === 'string') {
          // Built-in rule (like 'notEmpty')
          var ruleValidator = validator.getRule(rule);
          if (ruleValidator === undefined) return;
          if (!ruleValidator.handler.call(fields, f.value)) {
            errors[f.name] = message || ruleValidator.errorMessage;
          }
        } else if (typeof rule === 'function') {
          // Custom rule function
          if (!rule(f.value)) {
            errors[f.name] = message || 'Validation failed';
          }
        }
      });
    });
    if (Object.keys(errors).length === 0) {
      setFields(fields.map(f => _objectSpread(_objectSpread({}, f), {}, {
        error: undefined
      })));
    } else {
      setFields(fields.map(f => {
        if (!errors[f.name]) {
          return _objectSpread(_objectSpread({}, f), {}, {
            error: undefined
          });
        }
        return _objectSpread(_objectSpread({}, f), {}, {
          error: errors[f.name]
        });
      }));
    }
    return errors;
  };
  var submit = async e => {
    e.preventDefault();
    setState('submitting');
    try {
      PubSub.publishSync(FORM_SUBMIT, {
        props
      });
      var errors = validate();
      PubSub.publishSync(FORM_VALIDATED, {
        formId: id,
        errors
      });
      if (Object.keys(errors).length === 0) {
        var formData = new FormData(document.getElementById(id));
        setLoading(true);
        if (onStart) {
          await onStart();
        }
        var response = await fetch(
        // TODO: Replace by Axios
        action, {
          method,
          body: isJSON === true ? JSON.stringify(serializeForm(formData.entries(), dataFilter)) : formData,
          headers: _objectSpread({
            'X-Requested-With': 'XMLHttpRequest'
          }, isJSON === true ? {
            'Content-Type': 'application/json'
          } : {})
        });
        if (!response.headers.get('content-type') || !response.headers.get('content-type').includes('application/json')) {
          throw new TypeError('Something wrong. Please try again');
        }
        var responseJson = await response.json();
        if (get(responseJson, 'data.redirectUrl') !== undefined) {
          window.location.href = responseJson.data.redirectUrl;
          return true;
        }
        if (onSuccess) {
          await onSuccess(responseJson);
        }
        setState('submitSuccess'); // This indicates that the form has been submitted successfully. It does not mean that the business logic is successful.
        // Wait a bit to ensure that the success state is captured by other components
        await new Promise(resolve => setTimeout(resolve, 500));
      } else {
        setState('validateFailed');
        if (onValidationError) {
          await onValidationError();
        }
        // Get the first field with error
        var firstFieldWithError = Object.keys(errors)[0];
        // Get the first element with the name of the field with error
        var firstElementWithError = document.getElementsByName(firstFieldWithError)[0];
        // Focus on the first element with error
        if (firstElementWithError) {
          firstElementWithError.focus();
        }
      }
    } catch (error) {
      setState('submitFailed');
      if (onError) {
        await onError(error);
      }
      throw error;
    } finally {
      setLoading(false);
      setState('submitted');
      if (onComplete) {
        await onComplete();
      }
    }
    return true;
  };

  // Function to trigger form submission
  var triggerSubmit = () => {
    document.getElementById(id).dispatchEvent(new Event('submit', {
      cancelable: true,
      bubbles: true
    }));
  };

  // Render different button based on type
  var renderButton = () => {
    // If type is continue, render custom continue button
    if (type === 'continue' || type === 'placeOrder') {
      return /*#__PURE__*/React.createElement("div", {
        className: "form-continue-button flex mt-8 justify-between ".concat(continueButtonClass || '')
      }, /*#__PURE__*/React.createElement("div", {
        className: " items-center hidden md:flex gap-8"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        className: "text-white font-bold text-[1.6rem] flex items-center gap-[1rem]",
        onClick: e => {
          e.preventDefault();

          // Go back one page in the browser history
          window.history.back();
        }
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 12 12",
        fill: "none"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M1.01211 6.33201L5.69961 11.0195C5.76517 11.0851 5.84872 11.1298 5.9397 11.148C6.03068 11.1661 6.12498 11.1568 6.21068 11.1213C6.29638 11.0858 6.36962 11.0256 6.42112 10.9485C6.47262 10.8713 6.50007 10.7806 6.5 10.6879V7.13181L10.3871 11.0195C10.4527 11.0851 10.5362 11.1298 10.6272 11.148C10.7182 11.1661 10.8125 11.1568 10.8982 11.1213C10.9839 11.0858 11.0571 11.0256 11.1086 10.9485C11.1601 10.8713 11.1876 10.7806 11.1875 10.6879V1.31287C11.1876 1.22011 11.1601 1.12941 11.1086 1.05225C11.0571 0.975099 10.9839 0.914961 10.8982 0.879452C10.8125 0.843943 10.7182 0.83466 10.6272 0.852777C10.5362 0.870895 10.4527 0.915598 10.3871 0.981229L6.5 4.86892V1.31287C6.50007 1.22011 6.47262 1.12941 6.42112 1.05225C6.36962 0.975099 6.29638 0.914961 6.21068 0.879452C6.12498 0.843943 6.03068 0.83466 5.9397 0.852777C5.84872 0.870895 5.76517 0.915598 5.69961 0.981229L1.01211 5.66873C0.968527 5.71226 0.933951 5.76396 0.910362 5.82087C0.886773 5.87777 0.874632 5.93877 0.874632 6.00037C0.874632 6.06197 0.886773 6.12297 0.910362 6.17987C0.933951 6.23678 0.968527 6.28848 1.01211 6.33201Z",
        fill: "#F8F8F8",
        fillOpacity: "0.972549"
      })), /*#__PURE__*/React.createElement("p", {
        className: "text-[#f8f8f8] font-bold uppercase md:text-[2rem] text-[1.8rem]"
      }, "Delivery Bag"))), storeStatus === '0' &&
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/control-has-associated-label
      React.createElement("button", {
        type: "button",
        className: "cursor-not-allowed disabled:bg-[#6A6A6A] hover:bg-primary-dark text-white py-[1rem] px-[2.7rem] ml-auto rounded-[0.8rem] focus:outline-none focus:ring-2 focus:ring-primary-light flex items-center justify-center relative min-w-[180px]",
        disabled: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-center gap-2 transition-opacity ".concat(loading ? 'opacity-0' : 'opacity-100')
      }, /*#__PURE__*/React.createElement("p", {
        className: "font-bold uppercase text-[2rem]"
      }, btnText || 'Continue'), /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M20.7806 12.5312L13.2806 20.0312C13.1757 20.1362 13.042 20.2078 12.8965 20.2367C12.7509 20.2657 12.6 20.2509 12.4629 20.1941C12.3258 20.1372 12.2086 20.041 12.1262 19.9176C12.0438 19.7941 11.9999 19.649 12 19.5006V13.8109L5.78063 20.0312C5.67573 20.1362 5.54204 20.2078 5.39648 20.2367C5.25092 20.2657 5.10002 20.2509 4.96291 20.1941C4.82579 20.1372 4.70861 20.041 4.62621 19.9176C4.54381 19.7941 4.49988 19.649 4.5 19.5006V4.50059C4.49988 4.35217 4.54381 4.20705 4.62621 4.0836C4.70861 3.96016 4.82579 3.86394 4.96291 3.80712C5.10002 3.75031 5.25092 3.73546 5.39648 3.76444C5.54204 3.79343 5.67573 3.86496 5.78063 3.96997L12 10.1903V4.50059C11.9999 4.35217 12.0438 4.20705 12.1262 4.0836C12.2086 3.96016 12.3258 3.86394 12.4629 3.80712C12.6 3.75031 12.7509 3.73546 12.8965 3.76444C13.042 3.79343 13.1757 3.86496 13.2806 3.96997L20.7806 11.47C20.8504 11.5396 20.9057 11.6223 20.9434 11.7134C20.9812 11.8044 21.0006 11.902 21.0006 12.0006C21.0006 12.0992 20.9812 12.1967 20.9434 12.2878C20.9057 12.3788 20.8504 12.4616 20.7806 12.5312Z",
        fill: "#F8F8F8",
        fillOpacity: "0.972549"
      })))), storeStatus === '1' && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "bg-bremerRed disabled:bg-[#6A6A6A] hover:bg-primary-dark text-white py-[1rem] px-[2.7rem] ml-auto rounded-[0.8rem] focus:outline-none focus:ring-2 focus:ring-primary-light flex items-center justify-center relative min-w-[180px]",
        onClick: triggerSubmit,
        disabled: loading
      }, loading && /*#__PURE__*/React.createElement("span", {
        className: "absolute inset-0 flex items-center justify-center"
      }, /*#__PURE__*/React.createElement("span", {
        className: "loader w-6 h-6"
      })), /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-center gap-2 transition-opacity ".concat(loading ? 'opacity-0' : 'opacity-100')
      }, /*#__PURE__*/React.createElement("p", {
        className: "font-bold uppercase text-[2rem]"
      }, btnText || 'Continue'), /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M20.7806 12.5312L13.2806 20.0312C13.1757 20.1362 13.042 20.2078 12.8965 20.2367C12.7509 20.2657 12.6 20.2509 12.4629 20.1941C12.3258 20.1372 12.2086 20.041 12.1262 19.9176C12.0438 19.7941 11.9999 19.649 12 19.5006V13.8109L5.78063 20.0312C5.67573 20.1362 5.54204 20.2078 5.39648 20.2367C5.25092 20.2657 5.10002 20.2509 4.96291 20.1941C4.82579 20.1372 4.70861 20.041 4.62621 19.9176C4.54381 19.7941 4.49988 19.649 4.5 19.5006V4.50059C4.49988 4.35217 4.54381 4.20705 4.62621 4.0836C4.70861 3.96016 4.82579 3.86394 4.96291 3.80712C5.10002 3.75031 5.25092 3.73546 5.39648 3.76444C5.54204 3.79343 5.67573 3.86496 5.78063 3.96997L12 10.1903V4.50059C11.9999 4.35217 12.0438 4.20705 12.1262 4.0836C12.2086 3.96016 12.3258 3.86394 12.4629 3.80712C12.6 3.75031 12.7509 3.73546 12.8965 3.76444C13.042 3.79343 13.1757 3.86496 13.2806 3.96997L20.7806 11.47C20.8504 11.5396 20.9057 11.6223 20.9434 11.7134C20.9812 11.8044 21.0006 11.902 21.0006 12.0006C21.0006 12.0992 20.9812 12.1967 20.9434 12.2878C20.9057 12.3788 20.8504 12.4616 20.7806 12.5312Z",
        fill: "#F8F8F8",
        fillOpacity: "0.972549"
      })))));
    }

    // Default Button component
    return /*#__PURE__*/React.createElement("div", {
      className: "form-submit-button flex mt-4"
    }, /*#__PURE__*/React.createElement(Button, {
      title: btnText || _('Save'),
      onAction: triggerSubmit,
      isLoading: loading,
      type: "submit"
    }));
  };
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: _objectSpread({
      fields,
      addField,
      updateField,
      removeField,
      state
    }, props)
  }, /*#__PURE__*/React.createElement(FormDispatch.Provider, {
    value: {
      submit,
      validate
    }
  }, storeStatus === '0' && showStoreStatus && BusyPopup && /*#__PURE__*/React.createElement(BusyPopup, {
    onClose: () => setShowStoreStatus(false),
    redirectToHome: true
  }), /*#__PURE__*/React.createElement("form", {
    ref: formRef,
    id: id,
    action: action,
    method: method,
    onSubmit: e => submit(e)
  }, children, submitBtn === true && renderButton())));
}
Form.propTypes = {
  action: PropTypes.string,
  btnText: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  id: PropTypes.string.isRequired,
  method: PropTypes.string,
  onComplete: PropTypes.func,
  onError: PropTypes.func,
  onStart: PropTypes.func,
  onSuccess: PropTypes.func,
  onValidationError: PropTypes.func,
  submitBtn: PropTypes.bool,
  isJSON: PropTypes.bool,
  dataFilter: PropTypes.func,
  type: PropTypes.string,
  continueButtonClass: PropTypes.string,
  storeStatus: PropTypes.string
};
Form.defaultProps = {
  btnText: undefined,
  onComplete: undefined,
  onError: undefined,
  onStart: undefined,
  onSuccess: undefined,
  onValidationError: undefined,
  submitBtn: true,
  isJSON: true,
  action: '',
  method: 'POST',
  dataFilter: undefined,
  type: undefined,
  continueButtonClass: '',
  storeStatus: undefined
};
export var useFormContext = () => React.useContext(FormContext);
export var useFormDispatch = () => React.useContext(FormDispatch);